import Vue from "vue";
import VueRouter from "vue-router";
import Bakim from "../pages/Bakim.vue";
import Error from "../views/Error.vue";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import store from "../store";
// import axios from '../axios'
Vue.use(VueRouter);

/* function requireAuthandYetki(to, from, next) {
    //let vto = to
    if (!store.getters.isLogin) {
        next({ path: "/login" })
    }
         store.dispatch('setUser').then(() => {
            if (store.getters.isLogin) {
                if (vto.matched.some((record) => record.meta.yetki > store.getters.getUser.level)) {
                    next({ path: "/denied" })
                } else {
                    next();
                }
            } else {
                next({ path: "/login" })
            }
        }); 
} */

const routes = [
    {
        path: "/login",
        component: Login,
        meta: {
            requireAuth: false,
        },
    },

    { path: "*", redirect: "/" },

    {
        path: "/error",
        component: Error,
        meta: {
            requireAuth: false,
        },
    },
    {
        name: "Bakim",
        path: "/bakim",
        component: Bakim,
        meta: {
            requireAuth: false,
        },
    },

    {
        path: "/",
        component: Home,
        meta: {
            requireAuth: true,
        },
        children: [
            {
                path: "",
                name: "Dashboard",
                component: () =>
                    import(
                        /* webpackChunkName: "Dashboard" */ "../pages/Dashboard.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/patients",
                name: "Patients",
                component: () =>
                    import(
                        /* webpackChunkName: "Patients" */ "../views/Patients.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
                children: [
                    {
                        path: "/patients/yogunbakim",
                        name: "YogunBakim",
                        component: () =>
                            import(
                                /* webpackChunkName: "Yenidogan" */ "../pages/YogunBakim.vue"
                            ),
                        meta: {
                            requireAuth: true,
                        },
                    },
                    {
                        path: "/patients/yogunbakim/:id",
                        name: "YogunBakim",
                        component: () =>
                            import(
                                /* webpackChunkName: "YogunBakim" */ "../pages/YogunBakim.vue"
                            ),
                        props: true,
                        meta: {
                            requireAuth: true,
                        },
                    },
                    {
                        path: "/patients/servis",
                        name: "Servis",
                        component: () =>
                            import(
                                /* webpackChunkName: "Servis" */ "../pages/Servis.vue"
                            ),
                        meta: {
                            requireAuth: true,
                        },
                    },
                    {
                        path: "/patients/servis/:id",
                        name: "Servis",
                        component: () =>
                            import(
                                /* webpackChunkName: "Servis" */ "../pages/Servis.vue"
                            ),
                        props: true,
                        meta: {
                            requireAuth: true,
                        },
                    },
                    {
                        path: "/patients/servis/y/:id",
                        name: "YogunBakim",
                        component: () =>
                            import(
                                /* webpackChunkName: "Servis" */ "../pages/Servis.vue"
                            ),
                        props: true,
                        meta: {
                            requireAuth: true,
                        },
                    },
                ],
            },

            {
                path: "/yeniyd",
                name: "NewYD",
                component: () =>
                    import(
                        /* webpackChunkName: "NewYD" */ "../pages/NewYD.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/birthlist",
                component: () =>
                    import(
                        /* webpackChunkName: "Birthlist" */ "../pages/Birthlist.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/vizitlist",
                component: () =>
                    import(
                        /* webpackChunkName: "Vizitlist" */ "../pages/Vizitlist.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/deviryd",
                name: "DevirYD",
                component: () =>
                    import(
                        /* webpackChunkName: "DevirYD" */ "../pages/DevirYD.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/tcb",
                name: "TCB",
                component: () =>
                    import(/* webpackChunkName: "TCB" */ "../pages/TCB.vue"),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/arsiv",
                name: "Arsiv",
                component: () =>
                    import(
                        /* webpackChunkName: "Arsiv" */ "../pages/Arsiv.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },

            {
                path: "/yeniservis",
                name: "NewServis",
                component: () =>
                    import(
                        /* webpackChunkName: "NewServis" */ "../pages/NewServis.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/devir",
                name: "Devir",
                component: () =>
                    import(
                        /* webpackChunkName: "Devir" */ "../pages/Devir.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/ketoasidoz",
                name: "Ketoasidoz",
                component: () =>
                    import(
                        /* webpackChunkName: "Ketoasidoz" */ "../pages/Ketoasidoz.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/documents",
                name: "Documents",
                component: () =>
                    import(
                        /* webpackChunkName: "Documents" */ "../pages/Documents.vue"
                    ),
                meta: {
                    requireAuth: true,
                },
            },
            {
                path: "/documents/:id",
                name: "Document",
                component: () =>
                    import(
                        /* webpackChunkName: "Documents" */ "../pages/Documents.vue"
                    ),
                props: true,
                meta: {
                    requireAuth: true,
                },
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

function redirectGuard(to, from, next, page) {
    if (to.path != "/" + page) {
        next(false);
        next("/" + page);
    } else {
        next();
    }
}

function loginUser(to, from, next) {
    store
        .dispatch("loginUser")
        .then(() => {
            if (store.getters.isLogin) {
                next();
            } else {
                next(false);
                next("/login");
            }
        })
        .catch(() => {
            next(false);
            next("/login");
        });
}

function runApp(to, from, next) {
    if (to.path == "/bakim" || to.path == "/error") {
        next(false);
        next("/");
    } else {
        const requireAuth = to.matched.some(
            (record) => record.meta.requireAuth
        );
        if (requireAuth) {
            if (!store.getters.isLogin) {
                loginUser(to, from, next);
            } else {
                next();
            }
        } else {
            next();
        }
    }
}

router.beforeEach(async (to, from, next) => {
    //let vto = to
    switch (store.getters.getAppMode) {
        case -2:
            await store
                .dispatch("initializeApp")
                .then(() => {
                    if (store.getters.getAppMode == 1) {
                        runApp(to, from, next);
                    } else {
                        redirectGuard(to, from, next, "bakim");
                    }
                })
                .catch(() => {
                    redirectGuard(to, from, next, "error");
                });
            break;
        case -1:
            redirectGuard(to, from, next, "error");
            break;
        case 0:
            redirectGuard(to, from, next, "bakim");
            break;
        case 1:
            runApp(to, from, next);
            break;
    }
});

export default router;
